export const changeCardsIndicatorsQuality = (card1, card2, card3) => {
  return {
    type: "CHANGE_CARDS_INDICATORS_QUALITY",
    card1,
    card2,
    card3,
  };
};
